<template>
	<div class="d-inline-block mr-3 cursor-pointer" :style="{'width':width}" @click="goToDetail(data.id)">
    <div class="w-100 rounded-4 mb-2" style="overflow:hidden" :style="{'height':height+'px'}">
      <img :src="data.image_url" class="w-100 rounded-4 object-fit img-hover-zoom-in" :height="height">
    </div>
    <p class="mb-0 body-3-1">{{data.name}}</p>
    <p class="mb-0 body-3-1"><span class="font-extrabold text-green">{{formatCurrency(data.best_price)}}</span><span v-if="data.unit_name != null"> /{{data.unit_name}}</span></p>
  </div>
</template>
<script>
	import {formatCurrency} from '@/utils/index.js';
  import {mapGetters} from 'vuex';

	export default{
		props: {
			data:{
				type: Object
			},
			width:{
				type: String,
				default: '130px'
			},
			height:{ //px only
				type: Number,
				default: 160
			}
		},
		methods:{
			...mapGetters(['getMerchant']),
			formatCurrency(value){
        return formatCurrency(value);
      },
      goToDetail(id){
      	this.$router.push(`/${this.getMerchant().code}/concierge/experience/${this.data.id}`)
      }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/hotel/concierge/general/ThingsToDoItem.vue